import { Navigate, Outlet } from "react-router-dom";
import { usePermissions } from "../../hooks/usePermissions";

// Área do comprador: vendedores vão para o painel do vendedor
const BuyerGuard = () => {
  const { isSeller } = usePermissions();
  return isSeller ? <Navigate to="/seller/quotations" replace /> : <Outlet />;
};

export default BuyerGuard;
